module.exports = __webpack_public_path__ + "img/foldedHands.dbada927.png";